var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShuttleDropOffLocationIcon = function SvgShuttleDropOffLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99063 14.7281C8.98438 16.1969 10.4875 17.7875 12.5 19.5C14.5125 17.7875 16.0156 16.1969 17.0094 14.7281C18.0031 13.2594 18.5 11.9 18.5 10.65C18.5 8.775 17.8969 7.28125 16.6906 6.16875C15.4844 5.05625 14.0875 4.5 12.5 4.5C10.9125 4.5 9.51563 5.05625 8.30938 6.16875C7.10313 7.28125 6.5 8.775 6.5 10.65C6.5 11.9 6.99688 13.2594 7.99063 14.7281ZM12.4948 12.6654C13.9676 12.6654 15.1615 11.4715 15.1615 9.9987C15.1615 8.52594 13.9676 7.33203 12.4948 7.33203C11.022 7.33203 9.82812 8.52594 9.82812 9.9987C9.82812 11.4715 11.022 12.6654 12.4948 12.6654Z",
    fill: "#D93C00"
  })));
};
export default SvgShuttleDropOffLocationIcon;